<template>
  <div>
    <b-row>
      <b-col sm="6">
        <InputText
          title="Nome"
          field="name"
          :formName="formName"
          :required="true"
          :maxLength="40"
          v-model="unitOfMeasurement.name"
          :markFormDirty="false"
        />
      </b-col>
      <b-col sm="6">
        <RadioGroup
          title="Tipo"
          field="type"
          :formName="formName"
          :options="[
            { text: 'Inteiro', value: 1 },
            { text: 'Fracionado', value: 2 },
          ]"
          v-model="unitOfMeasurement.type"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <div class="text-right">
          <Button
            _key="btnSaveProductUnitOfMeasurement"
            type="success"
            title="Salvar"
            :disabled="!isFormValid(formName)"
            classIcon="fas fa-save"
            size="medium"
            :clicked="saveProductUnitOfMeasurement"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";
import RadioGroup from "@nixweb/nixloc-ui/src/component/forms/RadioGroup.vue";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";

import UnitOfMeasurement from "@/components/modules/stock/unit-of-measurement/UnitOfMeasurement.js";

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "UnitOfMeasurementCreateUpdate",
  props: {
    registerInSelect: Boolean,
    value: Object,
  },
  components: { Button, RadioGroup, InputText },
  data() {
    return {
      formName: "unitOfMeasurementCreateUpdate",
      unitOfMeasurement: new UnitOfMeasurement(),
      urlCreate: "/api/v1/stock/unit-of-measurement/create",
      urlUpdate: "/api/v1/stock/unit-of-measurement/update",
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
  },
  methods: {
    ...mapActions("generic", ["postApi", "putApi"]),
    ...mapMutations("generic", [
      "removeLoading",
      "removeEvent",
      "hideModal",
      "hideVodal",
    ]),
    ...mapMutations("validation", ["resetValidation"]),
    saveProductUnitOfMeasurement() {
      if (this.unitOfMeasurement.id) {
        let params = { url: this.urlUpdate, obj: this.unitOfMeasurement };
        this.putApi(params).then((response) => {
          if (response.success && !this.registerInSelect) this.hideModal();
          this.removeLoading(["btnSaveProductUnitOfMeasurement"]);
        });
      } else {
        let params = { url: this.urlCreate, obj: this.unitOfMeasurement };
        this.postApi(params).then((response) => {
          if (response.success && !this.registerInSelect) this.hideModal();
          if (response.success && this.registerInSelect) {
            this.$emit("input", {
              id: response.content.id,
              content: response.content.name,
            });
           this.hideVodal(this.formName);;
          }
          this.removeLoading(["btnSaveProductUnitOfMeasurement"]);
        });
      }
    },
    update(data) {
      this.unitOfMeasurement = new UnitOfMeasurement();
      this.unitOfMeasurement.update(data);
      this.removeLoading([data.id]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "productUnitOfMeasurementCreate") {
          this.resetValidation(this.formName);
          this.unitOfMeasurement = new UnitOfMeasurement();
        }
        if (event.name == "productUnitOfMeasurementUpdate") this.update(event.data);
      },
      deep: true,
    },
  },
};
</script>
